<template>
  <section class="pa-4">
    <v-card class="elevation-1">
      <v-row class="pa-3">
        <v-col
          v-for="(Actitem, index) in serieList"
          :key="Actitem.id || index"
          cols="12"
          sm="12"
          md="4"
        >
          <v-card
            style="
              padding: 15px;
              background: linear-gradient(
                to right,
                rgb(231, 217, 186),
                rgb(232, 218, 185)
              );
            "
          >
            <v-card-title class="text-h5">
              <span style="color: #000000; font-weight: bold">
                {{ Actitem.label }}
              </span>
            </v-card-title>

            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>

              <v-btn
                @click="redirectToActualityCategorie(Actitem)"
                color="#000000"
                text
              >
                Voir Plus
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </section>
</template>

<script>
import { FetchAllSubCategoriesByCategoryId } from '@/views/qorani/services/services'

export default {
  name: 'SubCategoriesList',
  data() {
    return {
      serieList: [],
    }
  },
  methods: {
  async  getAllSubCategoriesByCategoryId() {
      const categoryId = this.$route.params.id;
      try {
        const response = await FetchAllSubCategoriesByCategoryId(categoryId);
        this.serieList = response;
      } catch (error) {
        console.error('Error fetching subcategories:', error);
      }
    },
    redirectToActualityCategorie(serie) {
      this.$router.push({ name: 'SerieDetail', params: { id: serie.id , category: this.$route.params.category ,categoryid: this.$route.params.id} });
    },
  },
  async created() {
    await this.getAllSubCategoriesByCategoryId();
  },
}
</script>

<style scoped>
/* Ajoutez vos styles personnalisés ici si besoin */
</style>